import { render, staticRenderFns } from "./InfoData.vue?vue&type=template&id=57a513f1"
import script from "./InfoData.vue?vue&type=script&lang=js"
export * from "./InfoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports